export function Loading({ label = 'Загрузка…' }: { label?: string }) {
  return <div className="loading">{label}</div>;
}
